<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M13.9845 3.70161c0 1.21592-.9857 2.20162-2.2016 2.20162s-2.2016-.9857-2.2016-2.20162C9.5813 2.4857 10.567 1.5 11.7829 1.5s2.2016.9857 2.2016 2.20161ZM8.41097 7.94484c.07024-.77261.71804-1.36419 1.49384-1.36419h3.69589c.7758 0 1.4236.59157 1.4938 1.36419l.4047 4.45166c.0709.7802-.4669 1.465-1.2061 1.6083v7.3097c0 .6547-.5308 1.1855-1.1855 1.1855-.6548 0-1.1855-.5308-1.1855-1.1855v-7.2822h-.3387v7.2822c0 .6547-.5308 1.1855-1.1855 1.1855-.65473 0-1.18549-.5308-1.18549-1.1855v-7.3097c-.73926-.1433-1.27706-.8281-1.20613-1.6083l.40469-4.45166Z"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M9.27632 14.886v6.8721c0 .6859.55874 1.2419 1.24798 1.2419h2.8525c.6892 0 1.248-.556 1.248-1.2419V14.886c.7782-.1501 1.3444-.8675 1.2697-1.685l-.426-5.44926c-.074-.80941-.7559-1.42916-1.5726-1.42916h-3.8907c-.81668 0-1.49862.61975-1.57256 1.42916L8.00661 13.201c-.04127.4519.11323.8731.39111 1.1849.1131.1269.24664.2357.39574.321.14733.0843.30985.1457.48286.1791Zm1.11778-6.56342-.3652 4.67172 1.2474.2406V21h1.3485v-7.7651l1.2474-.2406-.3652-4.67172h-3.1129ZM11.9011 4c.2761 0 .5-.22386.5-.5s-.2239-.5-.5-.5c-.2762 0-.5.22386-.5.5s.2238.5.5.5Zm0 2c1.3807 0 2.5-1.11929 2.5-2.5s-1.1193-2.5-2.5-2.5-2.50001 1.11929-2.50001 2.5S10.5204 6 11.9011 6Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
